__turbopack_context__.v({
  "tooltip": "_-module__qecCfG__tooltip",
  "tooltipArrow": "_-module__qecCfG__tooltipArrow",
  "tooltipContainer": "_-module__qecCfG__tooltipContainer",
});
